__turbopack_context__.v({
  "modal": "Modal-module__-nvsMa__modal",
  "modalBody": "Modal-module__-nvsMa__modalBody",
});
